<template>
  <div>
    <v-stepper
      v-model="activeStep"
      vertical
      class="custom-header"
      non-linear
      flat
    >
      <v-form
        ref="formRef"
        class="multi-col-validation"
        @submit.prevent="handleSubmit"
      >
        <v-col
          col="12"
          sm="12"
        >
          <v-stepper-step
            editable
            :complete="activeStep > 1"
            step="1"
          >
            <div class="d-flex align-center">
              <span class="text--primary text-4xl font-weight-bold me-3">01</span>
              <div class="d-flex flex-column">
                <span class="text--primary text-sm font-weight-semibold">Nome</span>
                <span class="text--secondary text-xs">Escolha o nome do seu chatbot</span>
              </div>
            </div>
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="chatBotDataLocale.nome"
                label="Nome"
                dense
                outlined
                :rules="[validators.required, (v) => (!!v && v.length <= 50) || 'Máximo de 50 caracteres']"
              ></v-text-field>
              <v-btn
                color="primary"
                class="mt-2"
                @click="nextStep"
              >
                Próximo
              </v-btn>
            </v-col>
          </v-stepper-content>

          <v-stepper-step
            :complete="activeStep > 2"
            editable
            step="2"
          >
            <div class="d-flex align-center">
              <span class="text--primary text-4xl font-weight-bold me-3">02</span>
              <div class="d-flex flex-column">
                <span class="text--primary text-sm font-weight-semibold">Descrição</span>
                <span class="text--secondary text-xs">Descreve a função do seu chatbot</span>
              </div>
            </div>
          </v-stepper-step>

          <v-stepper-content step="2">
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="chatBotDataLocale.descricao"
                label="Descrição"
                hint="Máximo de 100 caracteres"
                dense
                outlined
              ></v-text-field>
              <div
                class="mt-2"
              >
                <v-btn
                  outlined
                  class="mr-2"
                  @click="previousStep"
                >
                  Voltar
                </v-btn>
                <v-btn
                  color="primary"
                  @click="nextStep"
                >
                  Próximo
                </v-btn>
              </div>
            </v-col>
          </v-stepper-content>

          <v-stepper-step
            :complete="activeStep > 3"
            editable
            step="3"
          >
            <div class="d-flex align-center">
              <span class="text--primary text-4xl font-weight-bold me-3">03</span>
              <div class="d-flex flex-column">
                <span class="text--primary text-sm font-weight-semibold">Mensagem inicial</span>
                <span class="text--secondary text-xs">Escolha a mensagem inicial da conversa do chatbot</span>
              </div>
            </div>
          </v-stepper-step>

          <v-stepper-content step="3">
            <v-col
              cols="12"
            >
              <v-textarea
                v-model="chatBotDataLocale.mensagemInicial"
                label="Mensagem Bot Inicial"
                dense
                outlined
                auto-grow
                rows="3"
                row-height="15"
                :rules="[validators.required]"
              ></v-textarea>
              <div
                class="mt-2"
              >
                <v-btn
                  outlined
                  class="mr-2"
                  @click="previousStep"
                >
                  Voltar
                </v-btn>
                <v-btn
                  color="primary"
                  @click="nextStep"
                >
                  Próximo
                </v-btn>
              </div>
            </v-col>
          </v-stepper-content>

          <v-stepper-step
            :complete="activeStep > 3"
            editable
            step="4"
          >
            <div class="d-flex align-center">
              <span class="text--primary text-4xl font-weight-bold me-3">04</span>
              <div class="d-flex flex-column">
                <span class="text--primary text-sm font-weight-semibold">Mensagem final</span>
                <span class="text--secondary text-xs">Escolha a mensagem final padrão da conversa do chatbot</span>
              </div>
            </div>
          </v-stepper-step>

          <v-stepper-content step="4">
            <v-col
              cols="12"
            >
              <v-textarea
                v-model="chatBotDataLocale.mensagemEncerramento"
                label="Mensagem Bot Final Default"
                dense
                outlined
                auto-grow
                rows="3"
                row-height="15"
                :rules="[validators.required]"
              ></v-textarea>
              <div
                class="mt-2"
              >
                <v-btn
                  outlined
                  class="mr-2"
                  @click="previousStep"
                >
                  Voltar
                </v-btn>
                <v-btn
                  color="primary"
                  @click="nextStep"
                >
                  Próximo
                </v-btn>
              </div>
            </v-col>
          </v-stepper-content>

          <v-stepper-step
            :complete="activeStep > 5"
            editable
            step="5"
          >
            <div class="d-flex align-center">
              <span class="text--primary text-4xl font-weight-bold me-3">05</span>
              <div class="d-flex flex-column">
                <span class="text--primary text-sm font-weight-semibold">Inatividade</span>
                <span class="text--secondary text-xs">Configure o alerta e o encerramento por inatividade enquanto o cliente navega no chatbot (antes de abrir um ticket)</span>
              </div>
            </div>
          </v-stepper-step>

          <v-stepper-content step="5">
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="chatBotDataLocale.timeoutAlertaChatBotMin"
                label="Tempo para alerta de inatividade (minutos)"
                type="number"
                dense
                outlined
                validate-on-blur
                min="1"
                max="10"
                :rules="[validators.required, validators.timeoutValidator]"
              ></v-text-field>
              <v-textarea
                v-model="chatBotDataLocale.timeoutAlertaChatBotMensagem"
                label="Mensagem de alerta de inatividade"
                hint="Máximo de 300 caracteres"
                dense
                outlined
                auto-grow
                rows="3"
                row-height="15"
                validate-on-blur
                :rules="[validators.required, (v) => (!!v && v.length <= 300) || 'Máximo de 300 caracteres']"
              ></v-textarea>
              <v-text-field
                v-model="chatBotDataLocale.timeoutEncerramentoChatBotMin"
                label="Tempo para encerramento por inatividade (minutos)"
                type="number"
                dense
                outlined
                validate-on-blur
                min="1"
                max="10"
                :rules="[validators.required, validators.timeoutValidator, validators.timeoutEncerramentoChatBotValidator]"
              ></v-text-field>
              <v-textarea
                v-model="chatBotDataLocale.timeoutEncerramentoChatBotMensagem"
                label="Mensagem de encerramento por inatividade"
                hint="Máximo de 300 caracteres"
                dense
                outlined
                auto-grow
                rows="3"
                row-height="15"
                validate-on-blur
                :rules="[validators.required, (v) => (!!v && v.length <= 300) || 'Máximo de 300 caracteres']"
              ></v-textarea>
              <div
                class="mt-2"
              >
                <v-btn
                  outlined
                  class="mr-2"
                  @click="previousStep"
                >
                  Voltar
                </v-btn>
                <v-btn
                  color="primary"
                  @click="nextStep"
                >
                  Próximo
                </v-btn>
              </div>
            </v-col>
          </v-stepper-content>

          <v-stepper-step
            :complete="activeStep > 6"
            editable
            step="6"
          >
            <div class="d-flex align-center">
              <span class="text--primary text-4xl font-weight-bold me-3">06</span>
              <div class="d-flex flex-column">
                <span class="text--primary text-sm font-weight-semibold">Uso do ChatBot</span>
                <span class="text--secondary text-xs">Escolha em qual plataforma o chatbot será usado</span>
              </div>
            </div>
          </v-stepper-step>

          <v-stepper-content step="6">
            <v-row
              class="d-flex justify-start"
            >
              <v-col
                cols="auto"
                class="d-flex flex-wrap"
              >
                <v-switch
                  v-model="plataformasLocale.WhatsApp"
                  label="WhatsApp"
                  @change="v => plataformaWhatsAppChanged(v)"
                />
              </v-col>
              <v-col
                cols="auto"
                class="d-flex flex-wrap"
              >
                <v-switch
                  v-model="plataformasLocale.Messenger"
                  label="Messenger"
                  @change="v => plataformaMessengerChanged(v)"
                />
              </v-col>
            </v-row>
            <v-btn
              outlined
              class="mt-2"
              @click="previousStep"
            >
              Voltar
            </v-btn>
          </v-stepper-content>
        </v-col>
        <div class="d-flex justify-center flex-wrap gap-4 mt-5">
          <v-btn
            outlined
            @click="resetForm"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="success"
            class="ms-2"
            :loading="loading"
            type="submit"
          >
            {{ isChatBotNovo ? 'Criar' : 'Salvar' }}
          </v-btn>
        </div>
      </v-form>
    </v-stepper>
  </div>
</template>

<script>
import {
  computed, inject, ref, watch,
} from '@vue/composition-api'
import { required, select } from '@core/utils/validation'
import Vue from 'vue'
import ChatBotService from '@/services/modules/ChatBotService'

export default {

  setup(props, { emit }) {
    const chatBotDataLocale = ref({})
    const chatBotData = inject('chatBotData')
    const idBot = ref(null)
    watch(() => chatBotData.value, value => {
      chatBotDataLocale.value = value
      idBot.value = chatBotDataLocale.value.id
    }, { immediate: true, deep: true })

    const activeStep = ref(1)
    const isChatBotNovo = computed(() => !chatBotData.value.id)

    watch(() => isChatBotNovo.value, value => {
      if (!value) activeStep.value = 6
    }, { immediate: true, deep: true })

    const formRef = ref(null)
    const loading = ref(false)

    function resetForm() {
      emit('cancelar-bot')
      formRef.value.reset()
    }

    function getRequestBody() {
      return {
        nome: chatBotData.value.nome,
        descricao: chatBotData.value.descricao,
        mensagemInicial: chatBotData.value.mensagemInicial,
        mensagemEncerramento: chatBotData.value.mensagemEncerramento,
        timeoutAlertaChatBotMin: chatBotData.value.timeoutAlertaChatBotMin,
        timeoutAlertaChatBotMensagem: chatBotData.value.timeoutAlertaChatBotMensagem,
        timeoutEncerramentoChatBotMin: chatBotData.value.timeoutEncerramentoChatBotMin,
        timeoutEncerramentoChatBotMensagem: chatBotData.value.timeoutEncerramentoChatBotMensagem,
      }
    }

    async function createChatBot() {
      try {
        loading.value = true
        idBot.value = await ChatBotService.criar(getRequestBody())
        loading.value = false

        emit('update:chat-bot-id', idBot.value)
      } catch {
        loading.value = false
      }
    }

    async function updateChatBot() {
      try {
        loading.value = true
        await ChatBotService.atualizar(idBot.value, getRequestBody())
        emit('update:chat-bot-id', idBot.value)
        loading.value = false
      } catch {
        loading.value = false
      }
    }

    async function handleSubmit() {
      if (loading.value) return
      if (formRef.value.validate()) {
        if (isChatBotNovo.value) {
          createChatBot()
        } else {
          updateChatBot()
        }
      } else {
        Vue.$toast.warning('Preencha corretamente os campos antes de salvar')
      }
    }

    function nextStep() {
      // eslint-disable-next-line no-plusplus
      activeStep.value++
    }

    function previousStep() {
      // eslint-disable-next-line no-plusplus
      activeStep.value--
    }

    const plataformasLocale = ref({})
    const plataformas = inject('chatBotPlataformas')
    watch(() => plataformas.value, value => {
      plataformasLocale.value = value
    }, { immediate: true, deep: true })

    async function plataformaWhatsAppChanged(value) {
      if (value === false) await ChatBotService.deleteChatBotConfigWhatsApp(idBot.value)
      emit('update:plataformas', plataformasLocale.value)
    }

    async function plataformaMessengerChanged(value) {
      if (value === false) await ChatBotService.deleteConfigMessenger(idBot.value)

      emit('update:plataformas', plataformasLocale.value)
    }

    function timeoutValidator(value) {
      const valueAsInteger = parseInt(value, 10)

      return (Number.isInteger(valueAsInteger) && valueAsInteger > 0 && valueAsInteger <= 10) || 'O timeout deve estar entre 1 e 10 minutos'
    }

    function timeoutEncerramentoChatBotValidator(value) {
      const timeoutEncerramento = parseInt(value, 10)
      const timeoutAlerta = parseInt(chatBotDataLocale.value.timeoutAlertaChatBotMin, 10)

      return timeoutEncerramento > timeoutAlerta || 'O tempo de encerramento deve ser maior que o tempo de alerta'
    }

    return {
      chatBotDataLocale,
      activeStep,
      formRef,
      loading,
      nextStep,
      previousStep,
      isChatBotNovo,
      handleSubmit,
      resetForm,
      plataformasLocale,
      plataformaWhatsAppChanged,
      plataformaMessengerChanged,
      validators: {
        required,
        select,
        timeoutValidator,
        timeoutEncerramentoChatBotValidator,
      },
    }
  },
}
</script>
